import React, { useMemo } from 'react';
import classes from './ExpireAfterCount.module.scss';
import { RegisterOptions, UseFormReturn, useWatch } from 'react-hook-form';
import { Select } from '../../../../components/forms/Select';
import { SelectItem } from '../../../../components/forms/Select/Select.view';
import pluralize from 'pluralize';
import { Tooltip } from '../../../../components/actions/Tooltip';
import classNames from 'classnames';
import { idGenerator } from '../../../../helpers/idGenerator';
import scssVars from '../../../../assets/scss/exportedVars.module.scss';

export type ExpireAfterCountViewProps = {
  //
  formInstance: UseFormReturn;
  name: string;
  disabled?: boolean;
  value?: number;
  expiryCountError?: string;
};

const items: SelectItem[] = (() => {
  let items: SelectItem[] = [];

  for (let i = 2; i <= 50; i++) {
    items = [
      ...items,
      {
        label: `${i}`,
        value: i
      }
    ];
  }
  return items;
})();

export const ExpireAfterCountView = ({
  formInstance,
  name,
  disabled,
  value,
  expiryCountError
}: ExpireAfterCountViewProps): JSX.Element => {
  const selectValueWatch = useWatch({ control: formInstance.control, name, defaultValue: value });

  const rules: RegisterOptions = {};
  const counterClasses = classNames(classes.ExpireAfterCount, {
    [classes.ErrorClass]: !disabled && expiryCountError
  });
  const id = useMemo(() => idGenerator(`expireAfterCount`), []);
  return (
    <div data-testid={'ExpireCount'} className={'grid-x align-middle'}>
      <div className={`cell shrink ${counterClasses}`}>
        <Select
          {...(value ? { selectedValue: +value, chooseLabel: value ? `${value}` : undefined } : {})}
          {...(disabled ? { readonly: true } : {})}
          items={items}
          name={name}
          rules={rules}
          size={'large'}
          useFormInstance={formInstance}
        />
      </div>
      <div className={'cell shrink'}>{pluralize('time', parseInt(selectValueWatch, 10))}</div>
      {expiryCountError && !disabled && (
        <div className={classNames('cell', 'shrink', classes.ExpireAfterCountTooltip)}>
          <Tooltip
            icon={'alert'}
            target={`#${id}`}
            position={'right'}
            pointer={true}
            type={'inlined'}
            autoZIndex={false}
            style={{ zIndex: scssVars['z-index-overmodal'] }}>
            <>{expiryCountError}</>
          </Tooltip>
        </div>
      )}
    </div>
  );
};
